import axios, { AxiosInstance } from 'axios';
import { BaseAuthService } from '../../../modules/users/services/auth/base_auth.service';

interface GetInterface {
    url: string;
    params?: object | null;
    headers?: object | null;
}

interface PostInterface {
    url: string;
    data?: any;
    params?: any;
    headers?: object | null;
    auth?: any;
}

export interface BaseAxiosClient {
    get({ url, params, headers }: GetInterface): Promise<any>;
    post({ url, data, params, headers, auth }: PostInterface): Promise<any>;
    put({ url, data, params, headers, auth }: PostInterface): Promise<any>;
    delete({ url, data, params, headers, auth }: PostInterface): Promise<any>;
}

class AxiosClient implements BaseAxiosClient {
    private axiosInstance: AxiosInstance;

    public authService?: BaseAuthService;

    constructor(authService?: BaseAuthService) {
        this.authService = authService;
        this.axiosInstance = axios.create({});
    }

    get({ url, params, headers }: GetInterface): Promise<any> {
        return this.axiosInstance({
            method: 'GET',
            url: url,
            params: params ?? null,
            headers: headers ?? null
        });
    }

    post({ url, data, params, headers, auth }: PostInterface): Promise<any> {
        return this.axiosInstance({
            method: 'POST',
            url: url,
            data: data ?? null,
            params: params ?? null,
            headers: headers ?? null,
            auth: auth ?? null
        });
    }

    put({ url, data, params, headers, auth }: PostInterface): Promise<any> {
        return this.axiosInstance({
            method: 'PUT',
            url: url,
            data: data ?? null,
            params: params ?? null,
            headers: headers ?? null,
            auth: auth ?? null
        });
    }

    delete({ url, data, params, headers, auth }: PostInterface): Promise<any> {
        return this.axiosInstance({
            method: 'DELETE',
            url: url,
            data: data ?? null,
            params: params ?? null,
            headers: headers ?? null,
            auth: auth ?? null
        });
    }
}

export default AxiosClient;
